import { addDoc, updateDoc } from 'firebase/firestore';
import { auth, collectionRef, notificationDoc } from '../firebase/config';
import { COLLECTIONS } from '../utils/constants';
import { formatDateTimeTR } from '../utils/dateUtils';
import { normalizeEmail, emailsMatch } from '../utils/emailUtils';
import { NOTIFICATION_CONTEXT } from '../utils/notificationContext';

const senderLoginId = (user) =>
  normalizeEmail(user?.email || user?.phoneNumber);

const resolveRecipientUid = (normalizedRecipient, context) => {
  if (context?.type === NOTIFICATION_CONTEXT.INSTRUCTOR_TO_STUDENT) {
    return context.studentId || null;
  }
  if (context?.type === NOTIFICATION_CONTEXT.STUDENT_TO_INSTRUCTOR) {
    return context.instructorId || null;
  }
  const sender = auth.currentUser;
  if (sender && emailsMatch(senderLoginId(sender), normalizedRecipient)) {
    return sender.uid;
  }
  return null;
};

/**
 * @param {string} userEmail Alıcı (e-posta veya telefon)
 * @param {string} text Mesaj
 * @param {{ context?: object }} [options] Çapraz kullanıcı bildirimleri için zorunlu
 */
export async function sendNotification(userEmail, text, options = {}) {
  if (!userEmail) return;

  const currentUser = auth.currentUser;
  const fromEmail = senderLoginId(currentUser);
  if (!fromEmail) {
    throw new Error('Bildirim göndermek için oturum gerekli.');
  }

  const normalizedRecipient = normalizeEmail(userEmail);
  const { context = null } = options;

  if (fromEmail !== normalizedRecipient && !context) {
    throw new Error('Çapraz kullanıcı bildirimi için context gerekli.');
  }

  const recipientUid = resolveRecipientUid(normalizedRecipient, context);

  await addDoc(collectionRef(COLLECTIONS.NOTIFICATIONS), {
    userEmail: normalizedRecipient,
    ...(recipientUid ? { recipientUid } : {}),
    fromEmail,
    text,
    time: formatDateTimeTR(new Date()),
    timestamp: Date.now(),
    read: false,
    ...(context ? { context } : {}),
  });
}

export async function markNotificationRead(notificationId) {
  await updateDoc(notificationDoc(notificationId), { read: true });
}
